<template>
  <div class="product_inf" style="">
    <card
      title="作业信息"
      style="color:#FFFFFF"
      v-if="CommodityJobInformation && (CommodityJobInformation.isShow === undefined || CommodityJobInformation.isShow)&&productType==0">
      <div style="padding:0rem 2rem 0.6rem 1.8rem;">
        <a-timeline style="margin-top:1rem">
          <a-timeline-item
            style="color:#faefac"
            color="#faefac"
            v-for="(item,index) in CommodityJobInformation.formdatas"
            :key="index">
            <div class="content_title widthStyle"> {{ item.titleWord }}</div>
            <div class="widthStyle"> {{ item.textualContent }}</div>
            <img :src="item.attachmentContent" alt="" width="98%">
          </a-timeline-item>
          <!--          <a-timeline-item style="color:#FFFFFF" color="#faefac">-->
          <!--            <div class="content_title"> 虫害检查</div>-->
          <!--            <img src="@/assets/日常检查病虫害.jpg" alt="" width="98%">-->
          <!--          </a-timeline-item>-->
          <!--          <a-timeline-item style="color:#FFFFFF" color="#faefac">-->
          <!--            <div class="content_title"> 生物防治</div>-->
          <!--            <img src="@/assets/诱捕杀.png" alt="" width="98%">-->
          <!--          </a-timeline-item>-->
        </a-timeline>
      </div>
    </card>
    <card title="生产加工流程" style="color:#FFFFFF"   v-if="CommodityJobInformation && (CommodityJobInformation.isShow === undefined || CommodityJobInformation.isShow)&&productType==1">
      <div style="padding:0rem 2rem 0.6rem 1.8rem;">
        <a-timeline style="margin-top:1rem">
          <a-timeline-item
            style="color:#faefac"
            color="#faefac"
            v-for="(item,index) in CommodityJobInformation.formdatas"
            :key="index">
            <div class="content_title widthStyle"> {{ item.titleWord }}</div>
            <div class="widthStyle"> {{ item.textualContent }}</div>
            <img :src="item.attachmentContent" alt="" width="98%">
          </a-timeline-item>
        </a-timeline>
      </div>
    </card>
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'
  import PreviewModal from './PreviewModal'

  export default {
    name: 'WorkInformation',
    components: { card, PreviewModal },
    props: {
      CommodityJobInformation: {
        type: Object,
        default: () => ({
          isShow: true,
          formdatas: []
        })
      },
      productType: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        logo: require('../../../assets/card/logo.png'),
        factory: require('../../../assets/card/factory.png'),
        reportData: [
          {
            name: '土壤环境检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '肥料检测报告',
            img: require('@assets/肥料检测报告.png')
          },
          {
            name: '种子检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '过程检测报告',
            img: require('@assets/text_book.png')
          },
          {
            name: '种子检验报告',
            img: require('@assets/seed_inspect_book.png')
          },
          {
            name: 'SGS飞行检查报告',
            img: require('@assets/SGS_book.png')
          }
        ]
      }
    },
    methods: {
      viewImg(url) {
        // 预览静态图片
        this.$refs.imageModal.show(url)
      }
    }
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 14rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.content_title {
  margin-bottom: 20px;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}


/deep/ .ant-timeline-item-head {
  background-color: #faefac;
}

.btn-view {
  font-size: 1rem;
  color: #FF0000
}
</style>
